import React, { useEffect, useState } from 'react'
import UserCreditProfile from '../../component/UserCreditProfile'
import HelpCenter from '../../component/HelpCenter'
import MobileNav from '../../component/MobileNav'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { getLeadHistory } from '../../Utils/api'
import { useSelector } from 'react-redux'
import PaymentHistory from '../../component/PaymentHistory'
import { dashboardStyles } from '../journey-pages/dashboardTheme'

const ldStyles = `
  .ld-page { min-height: 100vh; background: #eaf1fd; font-family: 'Sora', sans-serif; padding-bottom: 80px; }

  
  /* ── LAYOUT ── */
  .ld-layout {
    display: grid; grid-template-columns: 1fr 300px;
    gap: 1.5rem; max-width: 1200px;
    margin: 0 auto; padding: 2rem 1.5rem;
  }
  .ld-left { display: flex; flex-direction: column; gap: 1.25rem; min-width: 0; margin-top:50px ;}
  .ld-right { display: flex; flex-direction: column; gap: 1.25rem; margin-top:50px;  }

  /* BACK BUTTON */
  .ld-back {
    display: inline-flex; align-items: center; gap: 7px;
    padding: 8px 16px; border-radius: 10px;
    border: 1.5px solid #dce4f0; background: #fff;
    color: #0f1c2e; font-size: 13px; font-weight: 600;
    cursor: pointer; font-family: 'Sora', sans-serif;
    transition: border-color 0.15s, background 0.15s;
    width: fit-content;
  }
  .ld-back:hover { border-color: #b8cce8; background: #f7f9fc; }
  .ld-back svg { width: 15px; height: 15px; }

  /* ── HERO CARD (profile + status) ── */
  .ld-hero-card {
    background: #0f1c2e; border-radius: 20px;
    padding: 1.5rem 1.75rem; position: relative; overflow: hidden;
  }
  .ld-hero-blob1 { position: absolute; width: 220px; height: 220px; border-radius: 50%; background: radial-gradient(circle, rgba(55,138,221,0.2) 0%, transparent 70%); top: -60px; right: -40px; pointer-events: none; }
  .ld-hero-blob2 { position: absolute; width: 160px; height: 160px; border-radius: 50%; background: radial-gradient(circle, rgba(249,115,22,0.15) 0%, transparent 70%); bottom: -30px; left: -30px; pointer-events: none; }
  .ld-hero-grid { position: absolute; inset: 0; background-image: linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px); background-size: 36px 36px; pointer-events: none; }
  .ld-hero-inner { position: relative; z-index: 1; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1rem; }
  .ld-avatar { width: 48px; height: 48px; border-radius: 13px; background: #F97316; color: #fff; font-size: 18px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; overflow: hidden; }
  .ld-avatar img { width: 100%; height: 100%; object-fit: cover; }
  .ld-hero-name { font-size: 17px; font-weight: 700; color: #fff; letter-spacing: -0.3px; }
  .ld-hero-verified { display: flex; align-items: center; gap: 5px; font-size: 12px; color: #34d399; font-weight: 500; margin-top: 3px; }
  .ld-hero-verified svg { width: 13px; height: 13px; }
  .ld-hero-stats { display: flex; gap: 1rem; flex-wrap: wrap; }
  .ld-hero-stat { text-align: center; }
  .ld-hero-stat-label { font-size: 10px; color: rgba(255,255,255,0.45); text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }

  /* ── SUMMARY STATS ── */
  .ld-stats-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px; }
  .ld-stat-card { background: #fff; border-radius: 14px; padding: 14px; border: 1px solid #e8eef7; box-shadow: 0 2px 10px rgba(15,28,46,0.05); }
  .ld-stat-icon { width: 30px; height: 30px; border-radius: 8px; display: flex; align-items: center; justify-content: center; margin-bottom: 8px; }
  .ld-stat-icon svg { width: 14px; height: 14px; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
  .ld-stat-icon.blue { background: rgba(55,138,221,0.12); } .ld-stat-icon.blue svg { stroke: #378ADD; }
  .ld-stat-icon.orange { background: rgba(249,115,22,0.12); } .ld-stat-icon.orange svg { stroke: #F97316; }
  .ld-stat-icon.green { background: rgba(52,211,153,0.12); } .ld-stat-icon.green svg { stroke: #34d399; }
  .ld-stat-icon.purple { background: rgba(139,92,246,0.12); } .ld-stat-icon.purple svg { stroke: #8b5cf6; }
  .ld-stat-icon.red { background: rgba(226,75,74,0.1); } .ld-stat-icon.red svg { stroke: #E24B4A; }
  .ld-stat-label { font-size: 10px; color: #9aaabb; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 3px; }
  .ld-stat-val { font-size: 14px; font-weight: 700; color: #0f1c2e; letter-spacing: -0.2px; }

  /* ── DOC BUTTONS ── */
  .ld-doc-row { display: flex; gap: 10px; flex-wrap: wrap; }
  .ld-doc-btn {
    display: inline-flex; align-items: center; gap: 7px;
    padding: 9px 16px; border-radius: 10px;
    background: #0f1c2e; color: #fff;
    font-family: 'Sora', sans-serif;
    font-size: 13px; font-weight: 600;
    text-decoration: none; transition: background 0.15s;
  }
  .ld-doc-btn:hover { background: #1a2f4a; color: #fff; text-decoration: none; }
  .ld-doc-btn svg { width: 14px; height: 14px; fill: none; stroke: #fff; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

  /* ── INFO CARDS ── */
  .ld-info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .ld-info-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid #f0f4fa; gap: 8px; }
  .ld-info-row:last-child { border-bottom: none; }
  .ld-info-key { font-size: 11px; color: #9aaabb; text-transform: uppercase; letter-spacing: 0.4px; }
  .ld-info-val { font-size: 13px; font-weight: 500; color: #0f1c2e; text-align: right; }

  /* KYC CARDS */
  .ld-kyc-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
  .ld-kyc-card { display: flex; align-items: center; gap: 12px; padding: 14px; border-radius: 14px; border: 1px solid transparent; }
  .ld-kyc-card.blue { background: rgba(55,138,221,0.07); border-color: rgba(55,138,221,0.15); }
  .ld-kyc-card.orange { background: rgba(249,115,22,0.07); border-color: rgba(249,115,22,0.15); }
  .ld-kyc-card.green { background: rgba(52,211,153,0.07); border-color: rgba(52,211,153,0.15); }
  .ld-kyc-card.purple { background: rgba(139,92,246,0.07); border-color: rgba(139,92,246,0.15); }
  .ld-kyc-icon { width: 34px; height: 34px; border-radius: 9px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .ld-kyc-icon svg { width: 16px; height: 16px; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
  .ld-kyc-card.blue .ld-kyc-icon { background: rgba(55,138,221,0.15); } .ld-kyc-card.blue .ld-kyc-icon svg { stroke: #378ADD; }
  .ld-kyc-card.orange .ld-kyc-icon { background: rgba(249,115,22,0.15); } .ld-kyc-card.orange .ld-kyc-icon svg { stroke: #F97316; }
  .ld-kyc-card.green .ld-kyc-icon { background: rgba(52,211,153,0.15); } .ld-kyc-card.green .ld-kyc-icon svg { stroke: #34d399; }
  .ld-kyc-card.purple .ld-kyc-icon { background: rgba(139,92,246,0.15); } .ld-kyc-card.purple .ld-kyc-icon svg { stroke: #8b5cf6; }
  .ld-kyc-label { font-size: 10.5px; color: #9aaabb; text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 3px; }
  .ld-kyc-val { font-size: 13.5px; font-weight: 600; color: #0f1c2e; }

  /* ADDRESS CARD */
  .ld-address-card { padding: 14px 16px; background: #f7f9fc; border-radius: 14px; border: 1px solid #e8eef7; }
  .ld-address-text { font-size: 13.5px; color: #2d3748; line-height: 1.6; }

  /* RESPONSIVE */
  @media (max-width: 960px) { .ld-layout { grid-template-columns: 1fr; } .ld-right { order: -1; } }
  @media (max-width: 768px) { .ld-stats-grid { grid-template-columns: repeat(3, 1fr); } .ld-kyc-grid { grid-template-columns: 1fr; } }
  @media (max-width: 480px) {
    .ld-layout { padding: 1rem; gap: 1rem; }
    .ld-stats-grid { grid-template-columns: repeat(2, 1fr); }
    .ld-info-grid { grid-template-columns: 1fr; }
    .ld-nav { padding: 0 1rem; }
  }
`;

// ── Icons ──
const IconBolt = () => <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const IconBack = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>;
const IconVerified = () => <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>;
const IconDownload = () => <svg viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>;
const IconRupee = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="6" y1="4" x2="18" y2="4"/><line x1="6" y1="9" x2="18" y2="9"/><path d="M6 14l8 6"/><path d="M6 9a6 6 0 0 1 6 6"/></svg>;
const IconCalendar = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IconPercent = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>;
const IconClock = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IconHash = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/></svg>;
const IconUser = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IconMail = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const IconPhone = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>;
const IconCreditCard = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const IconPin = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
const IconTarget = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>;

export default function LoanDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { leadId } = location.state || {};
  const [leadData, setLeadData] = useState({});
  const customerDetails = useSelector((state) => state?.customerJourneyDetails?.customerDetails);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getLeadHistory({ leadId });
        if (response?.data?.status === 1) {
          setLeadData(response?.data?.data?.[0] || {});
        }
      } catch (error) { console.error('Error generating lead detail:', error); }
    };
    fetchData();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '—';
    return `${String(date.getDate()).padStart(2,'0')}-${String(date.getMonth()+1).padStart(2,'0')}-${date.getFullYear()}`;
  };
  const getMaritalStatus = (id) => ({ 1:'Single', 2:'Married', 3:'Divorced' }[Number(id)] || '—');
  const getGender = (id) => ({ 1:'Male', 2:'Female' }[Number(id)] || '—');

  const initials = customerDetails?.full_name
    ? customerDetails.full_name.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase()
    : '?';

  const docLinks = [
    { url: leadData?.sanction_letter, label: 'Sanction Letter' },
    { url: leadData?.disbursal_letter, label: 'Disbursal Letter' },
    { url: leadData?.noc_closing_letter, label: 'NOC Letter' },
    { url: leadData?.noc_settlement_letter, label: 'Settlement Letter' },
  ].filter(d => d.url);

  const stats = [
    { icon: <IconRupee />, label: 'Loan amount', val: leadData?.loan_recommended || '—', color: 'blue' },
    { icon: <IconHash />, label: 'Loan no.', val: leadData?.loan_no || '—', color: 'orange' },
    { icon: <IconCalendar />, label: 'Disbursal date', val: formatDate(leadData?.disbursal_date), color: 'green' },
    { icon: <IconPercent />, label: 'Interest rate', val: '1%', color: 'purple' },
    { icon: <IconClock />, label: 'Tenure', val: leadData?.tenure ? `${leadData.tenure} days` : '—', color: 'red' },
    { icon: <IconRupee />, label: 'Repay Amount', val: leadData?.loan_total_outstanding_amount || '—', color: 'blue' },
  ];

  const kycCards = [
    { icon: <IconRupee />, label: 'Monthly salary', val: leadData?.monthly_salary_amount || '—', color: 'blue' },
    { icon: <IconCreditCard />, label: 'PAN card', val: leadData?.pancard || '—', color: 'orange' },
    { icon: <IconUser />, label: 'Aadhaar number', val: customerDetails?.aadhar_no ? `••••••••${customerDetails.aadhar_no}` : '—', color: 'green' },
    { icon: <IconTarget />, label: 'Loan purpose', val: leadData?.purpose || '—', color: 'purple' },
  ];

  const personalRows = [
    { key: 'Customer name', val: customerDetails?.full_name },
    { key: 'Father name', val: customerDetails?.father_name },
    { key: 'Marital status', val: getMaritalStatus(customerDetails?.marital_status_id) },
    { key: 'Date of birth', val: formatDate(customerDetails?.dob) },
    { key: 'Gender', val: getGender(customerDetails?.gender) },
    { key: 'Mobile', val: leadData?.mobile },
    { key: 'Email', val: leadData?.email?.toLowerCase() },
  ];

  return (
    <>
      <style>{dashboardStyles}{ldStyles}</style>
      <div className="ld-page">

        {/* NAV */}
        

        <div className="ld-layout">
          <div className="ld-left">

            {/* BACK */}
            <button className="ld-back" onClick={() => navigate(-1)}>
              <IconBack /> Back to dashboard
            </button>

            {/* HERO CARD */}
            <div className="ld-hero-card">
              <div className="ld-hero-grid"/><div className="ld-hero-blob1"/><div className="ld-hero-blob2"/>
              <div className="ld-hero-inner">
                <div style={{ display:'flex', alignItems:'center', gap:14 }}>
                  <div className="ld-avatar">
                    {customerDetails?.profile_pic
                      ? <img src={customerDetails.profile_pic} alt="profile" onError={e=>e.target.style.display='none'}/>
                      : initials
                    }
                  </div>
                  <div>
                    <div className="ld-hero-name">{customerDetails?.full_name || '—'}</div>
                    <div className="ld-hero-verified"><IconVerified /> Verified account</div>
                  </div>
                </div>
                <div className="ld-hero-stats">
                  <div className="ld-hero-stat">
                    <div className="ld-hero-stat-label">App status</div>
                    <span className="db-badge warn">{leadData?.app_status || 'Pending'}</span>
                  </div>
                  <div className="ld-hero-stat">
                    <div className="ld-hero-stat-label">Loan no.</div>
                    <span style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:13, fontWeight:600, color:'#F97316' }}>
                      {leadData?.loan_no || '—'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* LOAN STATS */}
            <div className="db-card">
              <div className="db-section-title">Loan overview</div>
              <div className="ld-stats-grid">
                {stats.map((s,i) => (
                  <div key={i} className="ld-stat-card">
                    <div className={`ld-stat-icon ${s.color}`}>{s.icon}</div>
                    <div className="ld-stat-label">{s.label}</div>
                    <div className="ld-stat-val">{s.val}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* DOCUMENT BUTTONS */}
            {docLinks.length > 0 && (
              <div className="db-card">
                <div className="db-section-title">Documents</div>
                <div className="ld-doc-row">
                  {docLinks.map((doc, i) => (
                    <Link key={i} to={doc.url} target="_blank" className="ld-doc-btn">
                      <IconDownload /> {doc.label}
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {/* PERSONAL DETAILS */}
            <div className="db-card">
              <div className="db-section-title">Personal details</div>
              <div className="ld-info-grid">
                {personalRows.map((row, i) => (
                  <div key={i} className="ld-info-row">
                    <span className="ld-info-key">{row.key}</span>
                    <span className="ld-info-val">{row.val || '—'}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* KYC / FINANCIAL CARDS */}
            <div className="db-card">
              <div className="db-section-title">Financial & KYC info</div>
              <div className="ld-kyc-grid">
                {kycCards.map((card, i) => (
                  <div key={i} className={`ld-kyc-card ${card.color}`}>
                    <div className="ld-kyc-icon">{card.icon}</div>
                    <div>
                      <div className="ld-kyc-label">{card.label}</div>
                      <div className="ld-kyc-val">{card.val}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ADDRESS */}
            <div className="db-card">
              <div className="db-section-title">Current address</div>
              <div className="ld-address-card">
                <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                  <div style={{ width:30, height:30, borderRadius:8, background:'rgba(55,138,221,0.12)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <IconPin />
                  </div>
                  <p className="ld-address-text">
                    {[
                      customerDetails?.residence_address_1,
                      customerDetails?.residence_address_2,
                      customerDetails?.residence_city_name,
                      customerDetails?.residence_state_name,
                      customerDetails?.residence_pincode,
                    ].filter(Boolean).join(', ') || '—'}
                  </p>
                </div>
              </div>
            </div>

            {/* PAYMENT HISTORY */}
            <div className="db-card">
              <div className="db-section-title">Payment history</div>
              <PaymentHistory state={{ leadId }} />
            </div>

          </div>

          {/* RIGHT PANEL */}
          <div className="ld-right">
            <UserCreditProfile />
            <HelpCenter />
          </div>
        </div>
      </div>
      <MobileNav />
    </>
  );
}